import { PasswordField } from "../../common/ui/passwordField";
import type { GatewayProviderMeta } from "../../../constants/gatewayProviders";

interface StepCredentialsProps {
  provider: GatewayProviderMeta;
  configured: boolean;
  credentials: Record<string, string>;
  onCredentialChange: (key: string, value: string) => void;
  onDisconnect: () => void;
}

export const StepCredentials = ({
  provider,
  configured,
  credentials,
  onCredentialChange,
  onDisconnect,
}: StepCredentialsProps) => (
  <div className="space-y-4">
    <p className="text-size-sm text-global-secondary font-medium">
      Ingresa tus credenciales
    </p>

    {configured && (
      <div className="flex items-center justify-between px-3 py-2.5 rounded-lg bg-global-success">
        <div className="flex items-center gap-2">
          <div className="w-2 h-2 rounded-full shrink-0 bg-[var(--color-success-text)]" />
          <span className="text-size-xs font-medium text-global-success">
            Actualmente conectado
          </span>
        </div>
        <button
          type="button"
          onClick={onDisconnect}
          className="shrink-0 px-2.5 py-1 rounded-md text-size-2xs font-semibold text-global-error border border-(--color-error-border) hover:bg-global-error transition-colors duration-200 cursor-pointer"
        >
          Desconectar
        </button>
      </div>
    )}

    {provider.credentialFields.map((field) => (
      <div key={field.key}>
        <PasswordField
          label={configured ? `Actualizar ${field.label}` : field.label}
          value={credentials[field.key] ?? ""}
          onChange={(value) => onCredentialChange(field.key, value)}
          placeholder={field.placeholder}
        />
        {field.hint && (
          <p className="mt-1 text-size-2xs text-global-muted">{field.hint}</p>
        )}
      </div>
    ))}
  </div>
);
